<template>
  <v-footer>
    <div>
      <div class="copyrightText">{{ props.copyright }}</div>
      <div class="footerLinks">
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel1"
            :href="props.href[0]"
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          |
          <EgovLink
            class="footerLink"
            :label="props.linkLabel2"
            :href="props.href[1]"
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          |
          <EgovLink
            class="footerLink"
            :label="props.linkLabel3"
            :href="props.href[2]"
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
        </span>
        <span class="separator">|</span>
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel4"
            :href="props.href[3]"
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          |
          <EgovLink
            class="footerLink"
            :label="props.linkLabel5"
            :href="props.href[4]"
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
        </span>
      </div>
    </div>
  </v-footer>
</template>

<script setup>
import EgovLink from './EgovLink.vue'

const props = defineProps({
  copyright: { type: String, required: true },
  linkLabel1: { type: String, required: true },
  linkLabel2: { type: String, required: true },
  linkLabel3: { type: String, required: true },
  linkLabel4: { type: String, required: true },
  linkLabel5: { type: String, required: true },
  href: { type: Array, required: true },
})
</script>

<style lang="scss" scoped>
.v-footer {
  max-height: fit-content;
  width: 100vw;
  background-color: var(--kds-surface-container-highest);
  overflow: auto;
  -ms-overflow-style: normal;
  scrollbar-width: normal;

  @media (max-width: 728px) {
    justify-content: center;
  }
}
.v-footer > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: fit-content;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  justify-content: space-between;
  overflow: auto;
  -ms-overflow-style: normal;
  scrollbar-width: normal;

  @media (max-width: 728px) {
    justify-content: center;
  }
}

@media (min-width: 835px) {
  .v-footer {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

.v-footer::-webkit-scrollbar {
  display: normal;
}

@media (min-width: 835px) {
  .v-footer::-webkit-scrollbar {
    display: none;
  }
}

.copyrightText {
  display: inline-flex;
  font-size: 12.5px;
  align-items: center;
  color: var(--kds-on-surface);
  white-space: nowrap;

  @media (max-width: 728px) {
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
    white-space: normal;
  }
}

.footerLinks {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: small;
  color: var(--kds-on-surface);
  justify-content: center;
}

.footerRow {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

.footerLink {
  margin: 0px 5px;
  overflow: visible;

  :focus {
    color: var(--kds-on-surface);
  }
}

.separator {
  @media (max-width: 728px) {
    display: none;
  }
}
</style>